import PropTypes from "prop-types"
import { useLayoutEffect, useRef } from "react"
import { useLocation, useNavigationType } from "react-router-dom"

const ResetFocus = ({ navTopRef }) => {
  const location = useLocation()
  const action = useNavigationType()
  const prevPathname = useRef()

  if (typeof window !== "undefined") {
    useLayoutEffect(() => {
      // On path change, reset focus to the top
      if (
        navTopRef.current &&
        action !== "REPLACE" &&
        prevPathname.current !== location.pathname
      ) {
        prevPathname.current = location.pathname
        navTopRef.current.focus()
      }
    }, [navTopRef.current, action, location.pathname])
  }

  return null
}

ResetFocus.propTypes = {
  navTopRef: PropTypes.object,
}

export default ResetFocus
